import { render, staticRenderFns } from "./RecordingServer.vue?vue&type=template&id=5768e8db&scoped=true"
import script from "./RecordingServer.vue?vue&type=script&lang=js"
export * from "./RecordingServer.vue?vue&type=script&lang=js"
import style0 from "./RecordingServer.vue?vue&type=style&index=0&id=5768e8db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768e8db",
  null
  
)

export default component.exports